if (location.pathname.includes("/products/")) {
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
      const productButtonWrapper = document.querySelector(".productView-buttons.hidden:has(product-form .product-form__buttons)");
      productButtonWrapper.classList.remove("hidden");
    }, 1000);
  })
}